import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const keywordStore = new Vuex.Store({
    state: {
        loginStatue: '',
        formPeopleCarLogin: ''
    },
    getters: {
        getLoginStatue(state) {
            return state.loginStatue;
        },
        getFormPeopleCarLogin(state) {
            return state.formPeopleCarLogin;
        }
    },
    mutations: {
        setLoginStatue(state, loginStatue) {
            state.loginStatue = loginStatue;
        },
        setFormPeopleCarLogin(state, formPeopleCarLogin) {
            state.formPeopleCarLogin = formPeopleCarLogin;
        }
    },
    actions: {
        setLoginStatue({ commit }, loginStatue) {
            commit('setLoginStatue', loginStatue);
        },
        setFormPeopleCarLogin({ commit }, formPeopleCarLogin) {
            commit('setLoginStatue', formPeopleCarLogin);
        }
    },
    strict: process.env.NODE_ENV !== 'production'
});

export default keywordStore;


// WEBPACK FOOTER //
// ./src/vuex/index.js